module.exports = __webpack_public_path__ + "img/logo-giphar.37b1955.png";